import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import * as React from "react";
import {FormControl, InputLabel, Select} from "@mui/material";
import {Controller} from "react-hook-form";
import MenuItem from "@mui/material/MenuItem";
import {useState} from "react";
import toast from "react-hot-toast";
import useApi from "../Utils/api";

function MerchantStatusChangeSelectField(props) {
  const { value, index, ...other } = props;
  const [status, setStatus] = useState(value);
    const api = useApi();
  const changeMerchantStatus = (e) => {
      const statusValue = e.target.value;
      setStatus(statusValue)
      const data = {
          "merchantId": index,
          "status": statusValue
      };
      api.post("merchant/updateStatus",data)
          .then((response) => {
              if(response.data.statusCodeValue === 200) {
                  toast.success(response.data.body);
              } else {
                  toast.error(response.data.error);
              }
          })
          .catch((error) => {
              if (error.response && error.response.status === 403) {
                  toast.error("You do not have permission to perform this action.");
                  return;
              }
          })
  }

  return (
      <FormControl fullWidth style={{height: '35px', width: '130px'}} className="merchant-select">
        <InputLabel id={`merchant-status-select-label-${index}`}>Merchant Status</InputLabel>
        <Select
          labelId={`merchant-status-select-label-${index}`}
          id={`merchant-status-select-${index}`}
          label="Merchant Status"
          fullWidth
          style={{height: '100%'}}
          value={status}
          onChange={changeMerchantStatus}
        >
          <MenuItem value="">- Merchant Status -</MenuItem>
          <MenuItem value="1">Active</MenuItem>
          <MenuItem value="7" >InActive</MenuItem>
          <MenuItem value="3" >Block Merchant</MenuItem>
          <MenuItem value="5" >Block Transaction</MenuItem>
        </Select>
      </FormControl>
  );
}

MerchantStatusChangeSelectField.propTypes = {
  index: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default MerchantStatusChangeSelectField;